module.exports = "/fonts/vendor/tinymce/skins/lightgray/tinymce.svg?d031f47facf4331979b6f9fbac3187ef";